import {
  FETCH_EMPLOYEES_REQUEST,
  FETCH_EMPLOYEES_SUCCESS,
  FETCH_EMPLOYEES_FAILURE,
  UPDATE_EMPLOYEE_REQUEST,
  UPDATE_EMPLOYEE_SUCCESS,
  UPDATE_EMPLOYEE_FAILURE,
  UPDATE_EMPLOYEE_STATUS_REQUEST,
  UPDATE_EMPLOYEE_STATUS_SUCCESS,
  UPDATE_EMPLOYEE_STATUS_FAILURE,
} from "../actions/employeeActions";

const initialState = {
  employees: [],
  loading: false,
  error: null,
};

export default function employeeReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_EMPLOYEES_REQUEST:
    case UPDATE_EMPLOYEE_REQUEST:
    case UPDATE_EMPLOYEE_STATUS_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_EMPLOYEES_SUCCESS:
      return {
        ...state,
        loading: false,
        pagination: action.payload.meta?.pagination || null,
        employees: action.payload.data || [],
      };

    case UPDATE_EMPLOYEE_SUCCESS:
      return { ...state, loading: false };

    case UPDATE_EMPLOYEE_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        employees: state.employees.map((emp) =>
          emp.id === action.payload.user_id
            ? { ...emp, status: action.payload.status }
            : emp,
        ),
      };

    case FETCH_EMPLOYEES_FAILURE:
    case UPDATE_EMPLOYEE_FAILURE:
    case UPDATE_EMPLOYEE_STATUS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
}
